import { render, staticRenderFns } from "./SuggestionUserList.vue?vue&type=template&id=b0c546be&scoped=true"
import script from "./SuggestionUserList.vue?vue&type=script&lang=js"
export * from "./SuggestionUserList.vue?vue&type=script&lang=js"
import style0 from "./SuggestionUserList.vue?vue&type=style&index=0&id=b0c546be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c546be",
  null
  
)

export default component.exports